// extracted by mini-css-extract-plugin
module.exports = {"article":"PostListItem_article___ZdcX","title":"PostListItem_title__GlULB","description":"PostListItem_description__OpsM_"};